import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function removePurchaser(leadId, id) {
	var purchaserRef = firebaseRef.ref(
		'/kavtek_agreements/' +
			PROJECT_CODE.projectCode +
			'/' +
			leadId +
			'/clientInfo/individual/'
	);
	await purchaserRef.once('value', (snapshot) => {
		let individualObjs = snapshot.val();
		let individualObjsKeys = individualObjs && Object.keys(individualObjs);

		for (var i = 0; i < individualObjsKeys.length; i++) {
			let key = individualObjsKeys[i];
			if (individualObjs[key].id === id) {
				purchaserRef.child(key).remove();
				break;
			}
		}
	});
}
